// app/game/page.tsx
import React from 'react';
import { useUser } from '@clerk/nextjs'; // Import useUser from Clerk
import { useRouter } from 'next/router';

const GamePage = () => {
    const { isSignedIn } = useUser(); // Check if the user is signed in
    const router = useRouter();

    // Redirect to sign-in page if not authenticated
    React.useEffect(() => {
        if (!isSignedIn) {
            router.push('/sign-in'); // Redirect to sign-in page if user is not signed in
        }
    }, [isSignedIn, router]);

    return (
        <div>
            {/* Game content will only render if signed in */}
            {isSignedIn && (
                <>
                    <h1>Sail the Boat Game!</h1>
                    <div id="gameContainer">
                        <canvas id="landCanvas" width="500" height="500"></canvas>
                        <div id="boat" className="boat" style={{ top: '0', left: '0' }}></div>
                        {/* Other game elements go here... */}
                    </div>
                </>
            )}
        </div>
    );
};

export default GamePage;